import { AutoThemeProvider } from '@platform-ui/design-system';
import React from 'react';
import GenericTable from '../Tables/components/GenericTable';
import { APPLICATIONBUILDS_TABLE_PROPS } from '../Tables/constants';

const ApplicationBuildsView = (props) => {
    return (
        <AutoThemeProvider>
            <GenericTable {...APPLICATIONBUILDS_TABLE_PROPS} {...props} />
        </AutoThemeProvider>
    );
};

export default ApplicationBuildsView;